<app-loader *ngIf="showLoading"></app-loader>
<form [formGroup]="addTermsForm">
    <div class="main-wrapper">
        <app-header> </app-header>
        <app-leftmenu></app-leftmenu>
        <div class="page-wrapper">
            <div class="content container-fluid">
                <!-- Page Header -->
                <div class="page-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h3 class="page-title">{{PageTitle}}</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a routerLink="/Dashboard"> Dashboard</a>
                                </li>
                                <li class="breadcrumb-item active">{{PageTitle}}</li>
                            </ul>
                        </div>

                    </div>
                </div>
                <!-- /Page Header -->
                <div>
                    <app-potab highlightedtab="termstab" [additionalTerms]="!POEntityData.includeTerms"> </app-potab>
                </div>
                <div class="tab-content">

                    <!-- Add User -->
                    <div class="pro-overview tab-pane fade show active">
                        <div class="card">
                            <div class="card-body">

                                <div class="col-md-12 mandatory">*Fields are Mandatory</div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <!-- <div class="form-group">
                                            <mat-form-field class="example-full-width"
                                                [ngClass]="{ 'has-error': isSubmitted && formControls.uploadedTermsAnnexure.errors }">
                                                <mat-label>Upload Annexure</mat-label>
                                                <input matInput name="uploadedTermsAnnexure" type="text"
                                                    placeholder="Please enter annexure."
                                                    [(ngModel)]="POEntityData.uploadedTermsAnnexure" formControlName="uploadedTermsAnnexure"
                                                    maxlength="250" required>
                                                <div *ngIf="isSubmitted && formControls.uploadedTermsAnnexure.errors"
                                                    class="error-text">
                                                    <div *ngIf="formControls.uploadedTermsAnnexure.errors.required">Annexure is
                                                        required</div>
                                                </div>
                                            </mat-form-field>
                                        </div> -->
                                        <app-fileupload [files] = "uploadedTermsAnnexure" maxSize="15360" labelname="Upload Annexure" modulename="poannexure" [entitydata]="POEntityData.entityId"></app-fileupload>
                                    </div>

                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <mat-form-field class="example-full-width"
                                                [ngClass]="{ 'has-error': isSubmitted && formControls.additionalTerms.errors }">
                                                <mat-label>Additional Terms & Conditions</mat-label>
                                                <textarea matInput cols="55" rows="4" name="additionalTerms" type="text"
                                                    placeholder="Please enter additional terms & conditions."
                                                    [(ngModel)]="POEntityData.additionalTerms"
                                                    formControlName="additionalTerms" required>
                                                </textarea>
                                                <div *ngIf="isSubmitted && formControls.additionalTerms.errors"
                                                    class="error-text">
                                                    <div *ngIf="formControls.additionalTerms.errors.required">Additional terms & conditions are
                                                        required</div>
                                                </div>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="submit-section">
                                    <button mat-flat-button color="primary" (click)="updatePO()">
                                        <mat-icon aria-hidden="false">update</mat-icon> Save
                                    </button>

                                    <!-- <button mat-flat-button color="warn" (click)="cancel()">
                                        <mat-icon aria-hidden="false">close</mat-icon> Cancel
                                    </button> -->
                                </div>

                            </div>


                        </div>


                        <div>   
                            <div class="submit-section1">
                                <button mat-flat-button color="accent" (click)="openTask()" *ngIf="taskId==null">
                                    <mat-icon>send</mat-icon> Send For Approval
                                </button>
                                <button mat-flat-button color="accent" (click)="openTask()" *ngIf="taskId!=null">
                                    <mat-icon>send</mat-icon> Re-send For Approval
                                </button>
                            </div>

                            <div class="card" *ngIf="workflowDiv">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-4" *ngIf="rcId==null">
                                            <div class="form-group">
                                                <mat-form-field>
                                                    <mat-label>Workflow</mat-label>
                                                    <mat-select [(ngModel)]="TaskData.workflowName" name="workflowName"
                                                    [typeaheadDebounceInterval]="matSelectDuration"  formControlName="workflowName"
                                                        required>
                                                        <mat-option>-Select-</mat-option>
                                                        <mat-option *ngFor="let work of workflowList"
                                                            value="{{work.selectionid}}">
                                                            {{work.selectionvalue}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <mat-form-field class="example-full-width">
                                                    <mat-label>Remarks</mat-label>
                                                    <textarea matInput cols="55" rows="4" name="remark" type="text"
                                                        placeholder="Please enter remarks." formControlName="remark"
                                                        [(ngModel)]="TaskData.remark" maxlength="250" required>
                                                </textarea>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="submit-section">
                                        <button mat-flat-button color="primary" (click)="saveTask()">
                                            Submit
                                        </button>
                                        <button mat-flat-button color="warn" (click)="closeTask()">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>